var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mainUi',{attrs:{"pageRouterQuery":_vm.pageRouterRun,"pageRouterPath":_vm.typeRun}})
}
var staticRenderFns = []

export { render, staticRenderFns }